// 260919 스마트스토어 진입 한 곳 — 5곳에 흩어진 '준비 중' 리터럴(ServiceLanding·GenuineRegister·BusinessOwnerDashboard·QrManage·QrParkingRegister)의 수렴점.
//   스토어 오픈 시 여기만 QR_SMARTSTORE_URL window.open 으로 바꾼다(앱 안 외부 브라우저 처리는 그때 NativeCall 확인).
// 260923 대표 회의: 오픈 전까지 '준비 중' 안내 대신 사전 신청을 받는다("신청하기로 받아 주라 … 스마트가 열리면 그때 확 열자").
//   연락처(필수)·상호(선택)만 받고 '순서대로 담당자가 연락드립니다'. 접수 = POST /api/qr/pre-order(무인증) → 관리자 '문의 통합 관리'.
//   버튼 문구도 오픈 여부를 따라가야 해서(4곳) 라벨 상수를 같이 둔다.
import { show, modalList } from '@/common/utils/ModalState';
import { QR_SMARTSTORE_URL } from '@/common/constants/QrConst';

export const SMART_STORE_OPEN = false;

export const STORE_CTA_LABEL = SMART_STORE_OPEN ? '스마트스토어에서 구매하기' : '사전 신청하기';

// ctx: { entry(어느 버튼·품목에서 왔는지 — 관리자 메모), product(시트 제목 품목명), bizName(상호 미리 채움) }.
//   @click="openSmartStore" 처럼 이벤트 객체가 들어와도 아는 키만 골라 쓴다.
export const openPreOrder = (ctx = {}) => {
  const c = ctx || {};
  show(modalList.QR_PRE_ORDER_SHEET, {
    entry: typeof c.entry === 'string' ? c.entry : '',
    product: typeof c.product === 'string' ? c.product : '',
    bizName: typeof c.bizName === 'string' ? c.bizName : ''
  });
};

export const openSmartStore = (ctx = {}) => {
  if (!SMART_STORE_OPEN) {
    openPreOrder(ctx);
    return;
  }
  window.open(QR_SMARTSTORE_URL, '_blank', 'noopener');
};
